import React, { useState, useEffect } from 'react'
import DimLoader from   '../../../../templates/components/DimLoader'
import { renderToStaticMarkup } from 'react-dom/server';
import './react-draft-wysiwyg.css';
import './ViewTranscript.css'
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import TranscriptsService from '../../../../../services/api/transcripts.service';

const SummaryMarkup = (props) => {
    const convertSectionName = (sectionName) => {
        return sectionName.replaceAll("_"," ");
    }
    const convertSummarizedSegment = (summarizedSegment) => {
        return summarizedSegment;
    }

    return (
        <>
        {   
            (
                props?.clinicalDocumentation && 
                props?.clinicalDocumentation?.ClinicalDocumentation?.Sections
            ) 
            ? 
            props?.clinicalDocumentation?.ClinicalDocumentation.Sections.map((section) => {
                return (
                    <div>
                        <label><span style={{ fontWeight: "bold" }}>{convertSectionName(section.SectionName)}</span></label>
                        <ul>
                            {section?.Summary ? section?.Summary.map((summary) => {
                                return (
                                    <>
                                        <li>{convertSummarizedSegment(summary.SummarizedSegment)}</li>
                                    </>
                                );
                                }) 
                            : null}
                        </ul>

                    </div>
                );
                }) 
            : null
        } 
        
        </>


    )

}


const ViewTranscript = (props) => {
    const [isLoader, setIsLoader] = useState(false)
    const [conversation, setConversation] = useState([])
    const [clinicalDocumentation, setClinicalDocumentation] = useState()

    const [editorState, setEditorState] = useState(() => EditorState.createEmpty(),);

    useEffect(() => {
        if (props?.transcript) {
            console.log(props?.transcript);

            setConversation(JSON.parse(props?.transcript.transcript));
            setClinicalDocumentation(JSON.parse(props?.transcript.summary));

            console.log(JSON.parse(props?.transcript.summary))

            ;
        }
    }, [props?.transcript]);

    useEffect(() => {
        if (clinicalDocumentation) {

            let html = ''
            if (props?.transcript.summaryHtml) {
                html = props?.transcript.summaryHtml
            }
            else {
                html = renderToStaticMarkup(<SummaryMarkup clinicalDocumentation={clinicalDocumentation}></SummaryMarkup>)
            }

            console.log(html)

            const contentBlock = htmlToDraft(html);
            if (contentBlock) {
              const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
              const newEditorState = EditorState.createWithContent(contentState);

              setEditorState(newEditorState)

            }

        }
    }, [clinicalDocumentation]);    

    const onChange = (newState) => {
        setEditorState(newState)
    }    

    useEffect(() => {
        if (editorState) {
            console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())))
        }
    }, [editorState]);    

    const onClickSave = () => {
        if (editorState) {
            setIsLoader(true)
            let reqObj = {
                Id: props?.transcript.id,
                summaryHTML: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            }
            console.log(reqObj)
            TranscriptsService.updateTranscriptHTML(reqObj)
                .then(res => {
                    setIsLoader(false)
                    console.log(res)
                    if (props.onClose) { props.onClose() }
                })
                .catch(err => {
                    setIsLoader(false)
                    console.error(err)
                })
        }
    }

    return (
        <>{isLoader? <DimLoader loadMessage="Saving"/>:null}

            <div className="field col-12">
                <Editor
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor"
                    editorState={editorState}
                    onEditorStateChange={onChange}
                />
            </div>
            
            <div className='col-12 d-flex justify-content-end mt-3 modal-button-bar three'>
                <div className='col-auto'>
                    <button className='btn btn-primary me-2 ' onClick={e => { e.preventDefault(); onClickSave(); }}>
                        Save
                    </button>
                    <button className='btn btn-secondary me-2' onClick={e => { e.preventDefault(); if (props.onClose) { props.onClose() } }}>
                        Close
                    </button>
                </div>
            </div>

        </>
    )
}

export default ViewTranscript